import snackBar from 'store/snackbars.store'

/**
 * Standard error handler for promise-catch and async-catch sites.
 *
 * Always logs to the console with a context tag so the failure is
 * searchable in devtools + captured by any global error reporter.
 * If `userMsg` is provided, shows it via the app snackbar so the user
 * knows the action failed.
 *
 * Use this instead of `.catch(() => {})`, `.catch(e => {})`, or
 * catches that only `console.log` — those are forbidden by ESLint.
 *
 * @example
 *   promise.catch(err => reportError(err, 'MyFeature.save',
 *     'Failed to save. Please try again.'))
 */
export function reportError(err: unknown, ctx: string, userMsg?: string): void {
  // eslint-disable-next-line no-console
  console.error(`[${ctx}]`, err)
  if (userMsg) {
    try {
      snackBar.showError(userMsg)
    } catch {
      // snackbar itself is best-effort — don't let a UI-notification
      // failure hide the underlying error from the console log above.
      // eslint-disable-next-line no-console
      console.error(`[${ctx}] snackBar.showError itself failed`)
    }
  }
}

export default reportError
